import type { DemandCalculation } from './types/DemandCalculation';
import type { DemandCategorySummary } from './types/DemandCategorySummary';
import type { DemandProductCategory } from './types/DemandProductCategory';

export const getDemandCategorySummaries = (
    calculation: Pick<DemandCalculation, 'total' | 'vessels'> | undefined,
    volumeField: 'historicalVolume' | 'adjustedVolume'
): DemandCategorySummary[] => {
    const categories = new Map<DemandProductCategory, DemandCategorySummary>();
    for (const vessel of calculation?.vessels ?? []) {
        for (const category of vessel.categories) {
            const volume = category.summary[volumeField];
            if (category.liftingCount === 0 && volume === 0) {
                continue;
            }
            const summary = categories.get(category.category) ?? {
                category: category.category,
                volume: 0,
                vesselCount: 0,
                sharePercent: 0,
            };
            summary.volume += volume;
            summary.vesselCount += 1;
            categories.set(category.category, summary);
        }
    }
    const totalVolume = calculation?.total[volumeField] ?? 0;
    return [...categories.values()].map((category) => ({
        ...category,
        sharePercent: totalVolume > 0 ? (category.volume / totalVolume) * 100 : 0,
    }));
};
